function validatePassword(pwd) {
    var res = { "status": false, "message": `Password must be 8 characters containing lowercase,uppercase letter,numbers and at least one special characters` };
    var pattern =  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/

    if (pattern.test(pwd)) {
        res.status = true;
        res.message = "valid";
    }
    return res;
}
function validatePhoneNumber(number) {
    var res = { "status": false, "message": `Invalid phone number` };
    var pattern = /^(\+?)[0-9-()]{10,17}$/

    if (pattern.test(number)) {
        res.status = true;
        res.message = "valid";
    }
    return res;
}

function validateEmailAddress(email) {
    var res = { "status": false, "message": `Invalid email address` };
    var pattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]{2,}$/

    if (pattern.test(email)) {
        res.status = true;
        res.message = "valid";
    }
    return res;
}


function validateText(field = "", name) {
    var res = { "status": false, "message": `${field[0].toUpperCase() + field.slice(1)} must be alpha numeric characters` };
    // var status = false;
    var pattern = /^[a-zA-Z0-9 !@.\-:',?()]+$/i;
    if (name!=null && name.trim()!=='') {//not empty
        // status = name != null && name.trim() != "";// pattern.test(name);
        if (pattern.test(name)) {
            res.status = true;
            res.message = "valid";
        }
    } else {
        res.message = `${field[0].toUpperCase() + field.slice(1)} must not be empty`;
    }

    return res;
}

function validateNumber(number) {
    var res = { "status": false, "message": "Must be digits " };

    var pattern = /^[1-9][0-9]*$/;
    if (!isNaN(number)) {
        if (pattern.test(parseInt(number))) {
            res.status = true;
            res.message = "valid";
        }
    }
    return res;
}

function validateFile(file_obj, allowed_format = ["png", "jpeg", "pdf", "xls", "xlsx"]) {
    var res = { "status": false, "message": "Invalid file" };
    var is_allowed = false, file_type_arr = [], file_type = null;
    if (file_obj == null) {
        res.message = "You should select a file";
    } else if (typeof (file_obj) == "object") {
        file_type_arr = file_obj.type.split("/");
        file_type = file_type_arr[1];
        if (file_obj.size > 0) {
            is_allowed = allowed_format.includes(file_type);
            if (is_allowed) {
                res.status = true;
                res.message = "valid";

            } else {
                res.message = `File type ${file_type} not allowed,allowed file types are ${allowed_format.join(",")}`;
            }
        } else {
            res.message = `Zero byte file not allowed`;
        }
    } else {
        res.message = "Invalid file";
    }
    return res;
}

export default {
    validatePhoneNumber,
    validateEmailAddress,
    validateNumber,
    validateText,
    validateFile,
    validatePassword
}
